import Flexed from "../layouts/Flexed";
import uploadOne from "../assets/uploadOne.webp";
import Storename from "../components/uploads/store-name/Storename";
import Logo from "../components/logo/Logo";
import PagePadding from "../layouts/PagePadding";
import useAuth from "../hooks/useAuth";
import File from "../components/uploads/file/File";

const Uploads = () => {
  const { user } = useAuth();
  return (
    <section className="-mt-20">
      <div className="pt-4 block lg:hidden">
        <PagePadding>
          <Logo />
        </PagePadding>
      </div>
      <Flexed>
        <div
          className={`flex mt-3 justify-start xl:justify-between w-full items-center flex-col lg:flex-row md:w-11/12 ${
            user.isSeller?.status ? "lg:w-full" : "lg:w-8/9"
          }`}
        >
          <img
            src={uploadOne}
            alt="thrifit customer"
            className={`${
              user.isSeller?.status ? "lg:pl-5" : "lg:pl-0"
            } w-full h-96 lg:h-auto object-cover lg:w-1/2`}
          />
          <div
            className={`h-full block overflow-scroll scrollbar-none ${
              user.isSeller?.status ? "" : "mt-0"
            } lg:flex lg:items-center p-5 md:p-0 md:pl-5 pt-3 md:pb-5 w-full xl:w-1/2`}
          >
            {user?.data?.roles.find((role) => role.code.includes("SELLER")) ? (
              <File />
            ) : (
              <Storename />
            )}
          </div>
        </div>
      </Flexed>
    </section>
  );
};

export default Uploads;
